import { get, post } from '../ReaderlyHttpClient';
import { BookCollection, BookDetails, BookShort, TopBook } from '../../Models/Books';

type BookFilter = {
  search?: string;
  pageIndex: number;
  pageCount: number;
  onlyInStock?: boolean;
};

export const getCollections = () => get<BookCollection[]>('/book-collections');

export const getCollectionBySlug = (slug: string) =>
  get<BookCollection>(`/book-collections/${encodeURIComponent(slug)}`, undefined, { suppressGlobalError: true });

export const getBooks = (filter: BookFilter) => post<BookShort[], BookFilter>('/Books', filter);

export const getBook = (id: string) => get<BookDetails>(`/Books/${id}`);

export type RentalStats = {
  totalRentals: number;
  monthRentals: number;
};

export const getRentalStats = () =>
  get<RentalStats>('/books/stats', undefined, { suppressGlobalError: true });

export const getTopBooks = (activeOnly: boolean, count = 20) =>
  get<TopBook[]>('/books/top', { activeOnly, count }, { suppressGlobalError: true });
